import ProductInsurance from "../../entities/product/ProductInsurance";
import { IProductInsurance } from "../../entities/product/types";

export default class ProductInsuranceFactory {

  public static createFromResponse(productInsurance: any, numberPriceRate: number): IProductInsurance {
    return new ProductInsurance(
      productInsurance.hisPolicies,
      numberPriceRate
    );
  }

}
